import { type HazmatClass, type Commodity } from './Commodity'
import { type HazmatPackingGroup } from './Commodity'
import { type FreightClass } from './FreightClass'
import { type WeightType, type PackageType } from './PackageType'

export type ShippingItem = {
  id?: string
  uuid?: string
  packageType?: PackageType
  packageCount?: number
  length?: number
  width?: number
  height?: number
  weight?: number
  stackable?: boolean
  turnable?: boolean
  commodities?: Commodity[]
  weightType?: WeightType
  pickupStopIndex?: number
  deliveryStopIndex?: number
  commodity?: string
  poNumber?: string
  soNumber?: string
  hazmat?: boolean
  hazmatClass?: HazmatClass
  hazmatPackingGroup?: HazmatPackingGroup
  freightClass?: FreightClass
  nmfcCode?: string
  hazmatProperShippingName?: string
}

export type ShippingItemsMeasures = {
  totalWeight?: number
  volume?: number
  density?: number
  linearFeet?: number
}

export function getTotalHandlingUnitCount(shippingItems: ShippingItem[]): number {
  return shippingItems.reduce((total, item) => total + Number(item.packageCount || 0), 0)
}
